document.addEventListener('DOMContentLoaded', function() {
  const cardsGrid = document.querySelector('.cards-grid__wrapper');
  const facetsWrapper = document.querySelector('#FacetsWrapperDesktop');
  const container = document.querySelector('.cards-grid .container');

  function moveCardsGrid() {
    if (window.innerWidth > 749) {
      if (cardsGrid && facetsWrapper) {
        facetsWrapper.insertAdjacentElement('afterend', cardsGrid);
      }
    } else {
      if (cardsGrid && container) {
        container.appendChild(cardsGrid);
      }
    }
  }

  // Initial placement based on screen size
  moveCardsGrid();

  // Adjust on window resize
  window.addEventListener('resize', moveCardsGrid);
});


// Product swatches fix - working goood, but just colors
// document.addEventListener("click", function(e){

//   const swatch = e.target.closest(".spf-product__swatch");
//   if(!swatch) return;

//   const card = swatch.closest(".spf-product-card");
//   if(!card) return;

//   const select = card.querySelector(".spf-product__variants");
//   if(!select) return;

//   const optionIndex = swatch.dataset.option;
//   const optionValue = swatch.dataset.optionValue;

//   let matchedOption = null;

//   [...select.options].forEach(option => {
//     if(option.dataset["option" + optionIndex] === optionValue){
//       matchedOption = option;
//     }
//   });

//   if(!matchedOption) return;

//   select.value = matchedOption.value;

//   const newImage = matchedOption.dataset.image;
//   const resizedImage = newImage ? newImage.replace(/_\d+x\d+/, "_360x360") : null;

//   const images = card.querySelectorAll("img.spf-product-card__image");
//   images.forEach(img => {
//     if(resizedImage){
//       img.src = resizedImage;
//       img.srcset = "";
//     }
//   });

// });

///
///

const COLLECTION_CARD_IMAGE_WIDTH = 720;

function getCollectionImageSource(image) {
  return [
    image?.dataset.src,
    image?.dataset.collectionOriginalSrc,
    image?.currentSrc,
    image?.src
  ].find((url) => url && !url.startsWith('data:image')) || null;
}

function resizeCollectionImageUrl(url, width = COLLECTION_CARD_IMAGE_WIDTH) {
  if (!url) return null;

  return url
    .replace('{width}', String(width))
    .replace(/_\d+x\d+(?=\.[a-z0-9]+(?:\?|$))/i, `_${width}x${width}`)
    .replace(/([?&]width=)\d+/, `$1${width}`);
}

// --- Coverage-size CSS masking (added by Claude, 2026-09-24) ---
// Instead of needing a separate full render per coverage size (S/M/XL),
// we render one base "no stickers" image plus two universal masks (S/M)
// that are shared across every design/colour preset, and composite them
// live with CSS mask-image. Scoped to specific products only below, so
// this cannot affect any card that isn't explicitly listed.
const COVERAGE_MASK_PRODUCTS = {
'acid-design-stickers-for-can-am-maverick-x3': {
baseFront: 'https://cdn.shopify.com/s/files/1/0853/7554/9705/files/MAVERICK_X3_-_FRONT_-_COVERAGE_NONE.png',
baseSide: 'https://cdn.shopify.com/s/files/1/0853/7554/9705/files/MAVERICK_X3_-_SIDE_-_COVERAGE_NONE.png',
maskSFront: 'https://cdn.shopify.com/s/files/1/0853/7554/9705/files/MAVERICK_X3_-_FRONT_-_COVERAGE_S.png',
maskSSide: 'https://cdn.shopify.com/s/files/1/0853/7554/9705/files/MAVERICK_X3_-_SIDE_-_COVERAGE_S.png',
maskMFront: 'https://cdn.shopify.com/s/files/1/0853/7554/9705/files/MAVERICK_X3_-_FRONT_-_COVERAGE_M.png',
maskMSide: 'https://cdn.shopify.com/s/files/1/0853/7554/9705/files/MAVERICK_X3_-_SIDE_-_COVERAGE_M.png',
},
};

function getCoverageMaskConfig(card) {
const link = card.querySelector('a[href*="/products/"]');
const href = link ? link.getAttribute('href') || '' : '';
const handle = Object.keys(COVERAGE_MASK_PRODUCTS).find((h) => href.includes(h));
return handle ? COVERAGE_MASK_PRODUCTS[handle] : null;
}

function injectCoverageMaskStyles() {
if (document.getElementById('coverage-mask-styles')) return;
const style = document.createElement('style');
style.id = 'coverage-mask-styles';
style.textContent = [
'.coverage-mask-base-front, .coverage-mask-base-side { transition: opacity .3s ease; }',
'.coverage-mask-base-front { opacity: 1; }',
'.coverage-mask-base-side { opacity: 0; }',
'.spf-product-card__image-wrapper.hover-effect:hover .coverage-mask-base-front { opacity: 0; }',
'.spf-product-card__image-wrapper.hover-effect:hover .coverage-mask-base-side { opacity: 1; }',
].join('\n');
document.head.appendChild(style);
}

function ensureCoverageBaseLayer(wrapper, className, src) {
let base = wrapper.querySelector('.' + className);
if (!base) {
base = document.createElement('img');
base.className = className;
base.setAttribute('aria-hidden', 'true');
base.alt = '';
base.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:contain;z-index:0;pointer-events:none;';
base.src = src;
wrapper.insertBefore(base, wrapper.firstChild);
}
return base;
}

function setCoverageMask(el, url) {
if (!el) return;
const css = url ? 'url(' + url + ')' : 'none';
el.style.maskImage = css;
el.style.webkitMaskImage = css;
el.style.maskSize = el.style.webkitMaskSize = '100% 100%';
el.style.maskRepeat = el.style.webkitMaskRepeat = 'no-repeat';
el.style.maskPosition = el.style.webkitMaskPosition = 'center';
el.style.maskMode = el.style.webkitMaskSourceType = css ? 'luminance' : 'match-source';
}

const coverageCompositeCache = {};

function loadCoverageImage(url) {
return new Promise(function (resolve, reject) {
const img = new Image();
img.crossOrigin = 'anonymous';
img.onload = function () { resolve(img); };
img.onerror = reject;
img.src = url;
});
}

function buildCoverageComposite(baseUrl, maskUrl, designUrl) {
const cacheKey = baseUrl + '|' + maskUrl + '|' + designUrl;
if (coverageCompositeCache[cacheKey]) return coverageCompositeCache[cacheKey];
const promise = Promise.all([
loadCoverageImage(baseUrl),
loadCoverageImage(maskUrl),
loadCoverageImage(designUrl)
]).then(function (imgs) {
const baseImg = imgs[0];
const maskImg = imgs[1];
const designImg = imgs[2];
const SIZE = 800;
const maskCanvas = document.createElement('canvas');
maskCanvas.width = SIZE;
maskCanvas.height = SIZE;
maskCanvas.getContext('2d').drawImage(maskImg, 0, 0, SIZE, SIZE);
const maskData = maskCanvas.getContext('2d').getImageData(0, 0, SIZE, SIZE);
const designCanvas = document.createElement('canvas');
designCanvas.width = SIZE;
designCanvas.height = SIZE;
const designCtx = designCanvas.getContext('2d');
designCtx.drawImage(designImg, 0, 0, SIZE, SIZE);
const designData = designCtx.getImageData(0, 0, SIZE, SIZE);
for (let i = 0; i < designData.data.length; i += 4) {
designData.data[i + 3] = maskData.data[i];
}
designCtx.putImageData(designData, 0, 0);
const outCanvas = document.createElement('canvas');
outCanvas.width = SIZE;
outCanvas.height = SIZE;
const outCtx = outCanvas.getContext('2d');
outCtx.drawImage(baseImg, 0, 0, SIZE, SIZE);
outCtx.drawImage(designCanvas, 0, 0);
return outCanvas.toDataURL('image/png');
}).catch(function () {
delete coverageCompositeCache[cacheKey];
return null;
});
coverageCompositeCache[cacheKey] = promise;
return promise;
}

function getSecondaryPristineUrl(secondary) {
  const current = secondary.dataset.collectionOriginalSrc || secondary.currentSrc || secondary.src;
  if (current && current.indexOf('data:') !== 0) {
  secondary.dataset.coveragePristineSrc = current;
  return current;
  }
  return secondary.dataset.coveragePristineSrc || null;
  }

  function applyCoverageCompositeToSecondary(secondary, baseUrl, maskUrl) {
  const designUrl = getSecondaryPristineUrl(secondary);
  if (!designUrl) return;
  const comboKey = baseUrl + '|' + maskUrl + '|' + designUrl;
  if (secondary.dataset.coverageCompositeSource === comboKey) return;
  buildCoverageComposite(baseUrl, maskUrl, designUrl).then(function (dataUrl) {
  if (!dataUrl) return;
  secondary.dataset.coverageCompositeSource = comboKey;
  secondary.removeAttribute('srcset');
  secondary.removeAttribute('data-srcset');
  secondary.sizes = '';
  secondary.src = dataUrl;
  });
  }

  function restoreSecondaryOriginal(secondary) {
  if (!secondary.dataset.coverageCompositeSource) return;
  const originalSrc = secondary.dataset.coveragePristineSrc;
  delete secondary.dataset.coverageCompositeSource;
  if (originalSrc) secondary.src = originalSrc;
  }
  
  function applyCoverageMask(card, opts) {
const config = getCoverageMaskConfig(card);
if (!config) return;

const wrapper = card.querySelector('.spf-product-card__image-wrapper');
if (!wrapper) return;
const design = wrapper.querySelector('.spf-product-card__image-main');
const secondary = wrapper.querySelector('.spf-product-card__image-secondary');
if (!design) return;

const sizeSwatch = card.querySelector('.spf-product__swatch.is-selected[data-option-value$="size"], .spf-product__swatch.is-selected[data-option-value$="Size"]');
const size = (sizeSwatch ? sizeSwatch.dataset.optionValue : 'XL size').trim().toLowerCase();

let maskFront = null;
let maskSide = null;
if (size.indexOf('s') === 0) {
maskFront = config.maskSFront;
maskSide = config.maskSSide;
} else if (size.indexOf('m') === 0) {
maskFront = config.maskMFront;
maskSide = config.maskMSide;
}

// XL uses the real pre-rendered design image directly, so skip
// creating/loading the "no stickers" base layer entirely for it.
if (maskFront) {
  injectCoverageMaskStyles();
  ensureCoverageBaseLayer(wrapper, 'coverage-mask-base-front', config.baseFront);
  } else {
  const existingFront = wrapper.querySelector('.coverage-mask-base-front');
  if (existingFront) existingFront.remove();
  }
  // The secondary (hover) image is composited on a canvas instead of using
  // CSS mask-image: mask-image was found to render unreliably on the
  // Globo-managed .spf-product-card__image-secondary element (correct for
  // some size/mask combinations, fully broken for others - a browser
  // rendering quirk, not a data problem). A manual canvas composite with
  // the same base/mask/design assets is always correct, so no
  // coverage-mask-base-side layer is needed any more either.
  const existingSide = wrapper.querySelector('.coverage-mask-base-side');
  if (existingSide) existingSide.remove();

  setCoverageMask(design, maskFront);

  if (secondary && !(opts && opts.skipSecondary)) {
  if (maskSide) {
  applyCoverageCompositeToSecondary(secondary, config.baseSide, maskSide);
  } else {
  restoreSecondaryOriginal(secondary);
  }
  }
}
// --- end coverage-size CSS masking ---


function getCollectionVariantImage(card, variantOption) {
  const optionImage = variantOption.dataset.image;
  const productImages = Array.from(card.querySelectorAll('img.spf-product-card__image'));

  // Globo does not always put a variant image in the <option>. Some cards
  // instead include the relevant product media as a hidden image associated
  // with one or more variant IDs.
  const variantId = String(variantOption.value);
  const matchingImage = productImages
    .find((image) => (image.dataset.variants || '')
      .split(',')
      .map((id) => id.trim())
      .includes(variantId));

  const matchingImageIndex = matchingImage ? productImages.indexOf(matchingImage) : -1;
  const followingImage = matchingImageIndex >= 0 ? productImages[matchingImageIndex + 1] : null;
  const secondaryImage = followingImage && !(followingImage.dataset.variants || '').trim()
    ? followingImage
    : null;

  if (optionImage) {
    return {
      element: matchingImage || null,
      secondaryElement: secondaryImage,
      url: resizeCollectionImageUrl(optionImage)
    };
  }

  // No URL on the option: use the product-media image associated with the
  // variant. Its immediately following unbound image is the corresponding
  // secondary/side view used by Globo's card hover effect.
  if (!matchingImage) return null;

  const originalImageUrl = getCollectionImageSource(matchingImage);

  if (!matchingImage.dataset.collectionOriginalSrc && originalImageUrl) {
    matchingImage.dataset.collectionOriginalSrc = originalImageUrl;
  }

  return {
    element: matchingImage,
    secondaryElement: secondaryImage,
    url: resizeCollectionImageUrl(originalImageUrl)
  };
}

function showCollectionVariantImage(card, imageData) {
  setTimeout(function() { applyCoverageMask(card, { skipSecondary: true }); }, 0);
  if (!imageData) return;

  const images = card.querySelectorAll('img.spf-product-card__image');

  const primaryImage = card.querySelector('img.spf-product-card__image[data-collection-primary-image]')
    || images[0];
  const defaultSecondaryImage = card.querySelector('img.spf-product-card__image[data-collection-secondary-image]')
    || images[1];

  if (primaryImage && !primaryImage.dataset.collectionPrimaryImage) {
    primaryImage.dataset.collectionPrimaryImage = 'true';
  }

  const imageToShow = imageData.element || primaryImage;
  const secondaryImageToShow = imageData.secondaryElement
    || (defaultSecondaryImage !== imageToShow ? defaultSecondaryImage : null);

  if (!imageToShow) return;

  if (!imageToShow.dataset.collectionOriginalSrc) {
    const originalImageUrl = getCollectionImageSource(imageToShow);
    if (originalImageUrl) {
      imageToShow.dataset.collectionOriginalSrc = originalImageUrl;
    }
  }

  if (secondaryImageToShow) {
    const secondarySrcset = secondaryImageToShow.getAttribute('srcset') || '';
    const hasResponsiveSource = secondarySrcset && !secondarySrcset.trim().startsWith('data:image');
    const secondaryImageUrl = resizeCollectionImageUrl(getCollectionImageSource(secondaryImageToShow));

    // Keep Globo's already loaded responsive srcset. Only replace its 1 px
    // lazy-load placeholder when this variant image has not been loaded yet.
    if (!hasResponsiveSource && secondaryImageUrl) {
      secondaryImageToShow.dataset.collectionOriginalSrc = secondaryImageUrl;
      secondaryImageToShow.src = secondaryImageUrl;
      secondaryImageToShow.dataset.src = secondaryImageUrl;
      secondaryImageToShow.srcset = '';
    }
  }

  images.forEach((image) => {
    const isSelectedImage = image === imageToShow;
    const isSecondaryImage = image === secondaryImageToShow;

    image.classList.toggle('spf-product-card__image-hidden', !isSelectedImage && !isSecondaryImage);
    image.classList.toggle('spf-product-card__image-secondary', isSecondaryImage);
    image.classList.toggle('spf-product-card__image-main', isSelectedImage);

    if (isSelectedImage) {
      image.style.setProperty('display', 'block', 'important');
    } else if (isSecondaryImage) {
      // Globo controls the secondary image through opacity on card hover.
      // An inline display:none would leave only the white card background.
      image.style.removeProperty('display');
    } else {
      image.style.setProperty('display', 'none', 'important');
    }
  });

  if (imageData.url) {
    imageToShow.src = imageData.url;
    imageToShow.dataset.src = imageData.url;
    imageToShow.srcset = '';

    applyCoverageMask(card);
  }
}

function renderCollectionColourSwatches(rootElement = document) {
  const colorMap = window.colorHexMap || {};
  const cards = rootElement.classList?.contains('spf-product-card')
    ? [rootElement]
    : Array.from(rootElement.querySelectorAll('.spf-product-card'));

  cards.forEach((card) => {
    card.querySelectorAll('.spf-product__swatch[data-option-value]').forEach((swatch) => {
      const colorNames = swatch.dataset.optionValue
        .split('/')
        .map((colorName) => colorName.trim().toLowerCase());

      if (colorNames.length < 1 || colorNames.length > 2) return;

      const [firstColor, secondColor] = colorNames.map((colorName) => colorMap[colorName]);
      if (!firstColor || (colorNames.length === 2 && !secondColor)) return;

      const swatchInner = swatch.querySelector('.spf-product__swatch-inner');
      if (!swatchInner) return;

      const background = secondColor
        ? `conic-gradient(${firstColor} 0deg 180deg, ${secondColor} 180deg 360deg)`
        : firstColor;

      // Product cards on the home page draw the colour directly on the outer
      // swatch. Reuse the same approach here instead of Globo's overlapping
      // elements, which produce a diagonal triangular split.
      swatch.style.background = background;
      swatch.classList.add('collection-colour-swatch');
      swatch.closest('.spf-product__swatchs')?.classList.add('collection-colour-swatches');
      swatchInner.replaceChildren();
    });
  });
}

function findCollectionVariantForSwatch(card, swatch) {
  const select = card.querySelector('.spf-product__variants');
  if (!select) return null;

  const optionIndex = swatch.dataset.option;
  const optionValue = swatch.dataset.optionValue;
  const selectedOptions = {};

  card.querySelectorAll('.spf-product__swatch.is-selected').forEach((s) => {
    selectedOptions[s.dataset.option] = s.dataset.optionValue;
  });

  selectedOptions[optionIndex] = optionValue;

  let matchedOption = null;

  [...select.options].forEach((option) => {
    let isMatch = true;

    for (const key in selectedOptions) {
      if (option.dataset[`option${key}`] !== selectedOptions[key]) {
        isMatch = false;
        break;
      }
    }

    if (isMatch) {
      matchedOption = option;
    }
  });

  return matchedOption;
}

// Keep the existing click behaviour: a click selects and persists the variant.
document.addEventListener('click', function(e) {
  const swatch = e.target.closest('.spf-product__swatch');
  if (!swatch) return;

  const card = swatch.closest('.spf-product-card');
  if (!card) return;

  const select = card.querySelector('.spf-product__variants');
  const matchedOption = findCollectionVariantForSwatch(card, swatch);
  if (!select || !matchedOption) return;

  select.value = matchedOption.value;
  card.dataset.collectionVariantImageManaged = 'true';
  showCollectionVariantImage(card, getCollectionVariantImage(card, matchedOption));
});

// Collection-only colour preview. Mouseover/out are delegated because Globo
// replaces product cards after filtering, sorting and pagination.
document.addEventListener('mouseover', function(e) {
  const swatch = e.target.closest('.collection-colour-swatch');
  if (!swatch || !swatch.closest('#gf-products')) return;
  if (e.relatedTarget && swatch.contains(e.relatedTarget)) return;

  const card = swatch.closest('.spf-product-card');
  if (!card) return;

  const matchedOption = findCollectionVariantForSwatch(card, swatch);
  if (!matchedOption) return;

  card.dataset.collectionVariantImageManaged = 'true';
  showCollectionVariantImage(card, getCollectionVariantImage(card, matchedOption));
});

document.addEventListener('mouseout', function(e) {
  const swatch = e.target.closest('.collection-colour-swatch');
  if (!swatch || !swatch.closest('#gf-products')) return;
  if (e.relatedTarget && swatch.contains(e.relatedTarget)) return;

  const card = swatch.closest('.spf-product-card');
  const select = card?.querySelector('.spf-product__variants');
  const selectedOption = select?.options[select.selectedIndex];

  if (!card || !selectedOption) return;

  showCollectionVariantImage(card, getCollectionVariantImage(card, selectedOption));
});

// Initial fix for product images on load and dynamic loading
function fixProductCardImages() {
    document.querySelectorAll('.spf-product-card').forEach(card => {
        if (card.dataset.collectionVariantImageManaged === 'true') return;

        const images = card.querySelectorAll('img.spf-product-card__image');
        if (images.length > 0) {
            images.forEach((img, index) => {
                img.toggleAttribute('data-collection-primary-image', index === 0);
                img.toggleAttribute('data-collection-secondary-image', index === 1);

                if (!img.dataset.collectionOriginalSrc) {
                    const originalImageUrl = getCollectionImageSource(img);
                    if (originalImageUrl) {
                        img.dataset.collectionOriginalSrc = originalImageUrl;
                    }
                }

                img.classList.remove('spf-product-card__image-main', 'spf-product-card__image-secondary', 'spf-product-card__image-hidden');
                if (index === 0) {
                    img.classList.add('spf-product-card__image-main');
                    img.style.setProperty('display', 'block', 'important');
                } else if (index === 1) {
                    img.classList.add('spf-product-card__image-secondary');
                    // We don't necessarily want to force display:block for secondary if it's used for hover effects
                    // But we must ensure it's not display:none if the theme expects it for hover
                    img.style.removeProperty('display');
                } else {
                    img.classList.add('spf-product-card__image-hidden');
                    img.style.setProperty('display', 'none', 'important');
                }
            });
        }
    });
}

const ANGLE_3D_TAGS = ['3d virtual customization', '3d customize'];
const angle3dByHandleCache = new Map();
const productLabelsByHandleCache = new Map();

function getAngle3dLogoUrl() {
    if (!document.body) return null;

    return document.body.getAttribute('data-angle-3d-logo')
        || document.body.dataset.angle3dLogo
        || null;
}

function getAngle3dCards(rootElement = document) {
    if (!rootElement) return [];

    if (rootElement.classList?.contains('spf-product-card')) {
        return [rootElement];
    }

    return Array.from(rootElement.querySelectorAll('.spf-product-card'));
}

function getProductLabelsHost(wrapper) {
    return wrapper.querySelector('.spf-product-card__inner') || wrapper.querySelector('.spf-product-card__image-wrapper');
}

function normalizeLabelContexts(showInValue) {
    if (Array.isArray(showInValue)) {
        return showInValue
            .map(value => String(value).trim().toLowerCase())
            .filter(Boolean);
    }

    return String(showInValue || '')
        .split(',')
        .map(value => value.trim().toLowerCase())
        .filter(Boolean);
}

async function getProductLabelsData(handle) {
    if (!handle) return null;

    if (!productLabelsByHandleCache.has(handle)) {
        const labelsPromise = fetch(`/products/${handle}`)
            .then(response => {
                if (!response.ok) throw new Error('Product page fetch failed');
                return response.text();
            })
            .then(html => {
                const parser = new DOMParser();
                const productDocument = parser.parseFromString(html, 'text/html');
                const labelsDataScript = productDocument.querySelector('[id^="ProductLabelsData-"]');

                if (!labelsDataScript || !labelsDataScript.textContent.trim()) {
                    return null;
                }

                const parsedData = JSON.parse(labelsDataScript.textContent);
                if (!parsedData || typeof parsedData !== 'object') {
                    return null;
                }

                return {
                    position: String(parsedData.position || 'top').trim().toLowerCase() === 'bottom' ? 'bottom' : 'top',
                    labels: Array.isArray(parsedData.labels) ? parsedData.labels : []
                };
            })
            .catch(() => null);

        productLabelsByHandleCache.set(handle, labelsPromise);
    }

    return productLabelsByHandleCache.get(handle);
}

function createCollectionProductLabelElement(label) {
    const styleKey = String(label.style_key || '').trim().toLowerCase();
    const className = styleKey ? `product-label product-label--${styleKey}` : 'product-label product-label--default';
    const url = String(label.url || '').trim();
    const text = String(label.text || '').trim();

    const element = url ? document.createElement('a') : document.createElement('span');
    element.className = className;

    if (url) {
        element.href = url;
    }

    const textElement = document.createElement('span');
    textElement.textContent = text;
    element.appendChild(textElement);

    return element;
}

async function syncCollectionProductLabels(wrapper) {
    if (!wrapper) return;

    const badgeHost = getProductLabelsHost(wrapper);
    if (!badgeHost) return;

    const existingLabels = badgeHost.querySelector('.product-labels--collections');
    const handle = wrapper.dataset.productHandle;
    const productLabelsData = await getProductLabelsData(handle);

    const collectionLabels = (productLabelsData?.labels || []).filter(label => {
        const text = String(label?.text || '').trim();
        if (!text) return false;

        const contexts = normalizeLabelContexts(label.show_in);
        return contexts.includes('collections');
    });

    if (!collectionLabels.length) {
        if (existingLabels) {
            existingLabels.remove();
        }
        return;
    }

    const labelsContainer = existingLabels || document.createElement('div');
    labelsContainer.className = `product-labels product-labels--${productLabelsData.position} product-labels--collections`;
    labelsContainer.setAttribute('aria-label', 'Product labels');
    labelsContainer.innerHTML = '';

    collectionLabels.slice(0, 3).forEach(label => {
        labelsContainer.appendChild(createCollectionProductLabelElement(label));
    });

    if (!existingLabels) {
        badgeHost.appendChild(labelsContainer);
    }
}

function syncAngle3dLabel(wrapper) {
    if (!wrapper) return;

    const logoUrl = getAngle3dLogoUrl();
    const badgeHost = getProductLabelsHost(wrapper);
    if (!badgeHost) return;

    const existingBadge = badgeHost.querySelector('.angle-3d-badge');

    if (!logoUrl || !wrapper.classList.contains('angle-3d-product')) {
        if (existingBadge) {
            existingBadge.remove();
        }
        return;
    }

    if (existingBadge) return;

    const badge = document.createElement('span');
    badge.className = 'angle-3d-badge';

    const badgeImage = document.createElement('img');
    badgeImage.src = logoUrl;
    badgeImage.alt = 'Angle 3D';
    badgeImage.loading = 'lazy';

    badge.appendChild(badgeImage);
    badgeHost.appendChild(badge);
}

function renderAngle3dLabels(rootElement = document) {
    const wrappers = rootElement.classList?.contains('angle-3d-card-wrapper')
        ? [rootElement]
        : Array.from(rootElement.querySelectorAll('.angle-3d-card-wrapper'));

    wrappers.forEach(syncAngle3dLabel);
}

function getProductHandleFromCard(card) {
    const link = card.querySelector('.spf-product-card__image-wrapper, .spf-product-card__title a');
    if (!link || !link.href) return null;

    try {
        const url = new URL(link.href, window.location.origin);
        const match = url.pathname.match(/\/products\/([^/?#]+)/);
        return match ? match[1] : null;
    } catch (error) {
        return null;
    }
}

async function isAngle3dProduct(handle) {
    if (!handle) return false;

    if (!angle3dByHandleCache.has(handle)) {
        const productPromise = fetch(`/products/${handle}.js`)
            .then(response => {
                if (!response.ok) throw new Error('Product fetch failed');
                return response.json();
            })
            .then(productData => {
                const productTags = Array.isArray(productData.tags)
                    ? productData.tags
                    : String(productData.tags || '').split(',');

                const normalizedTags = productTags.map(tag => String(tag).trim().toLowerCase());
                return normalizedTags.some(tag => ANGLE_3D_TAGS.includes(tag));
            })
            .catch(() => false);

        angle3dByHandleCache.set(handle, productPromise);
    }

    return angle3dByHandleCache.get(handle);
}

async function markAngle3dProducts(rootElement = document) {
    const cards = getAngle3dCards(rootElement);

    await Promise.all(cards.map(async (card) => {
        const cardWrapper = card.closest('.d-label') || card.parentElement;
        if (!cardWrapper) return;

        cardWrapper.classList.add('angle-3d-card-wrapper');

        const handle = getProductHandleFromCard(card);
        if (!handle) return;

        cardWrapper.dataset.productHandle = handle;

        const [is3d] = await Promise.all([
            isAngle3dProduct(handle),
            syncCollectionProductLabels(cardWrapper)
        ]);

        cardWrapper.classList.toggle('angle-3d-product', is3d);
        syncAngle3dLabel(cardWrapper);
    }));
}

// Observe for DOM changes to catch dynamically loaded products (infinite scroll)
const observer = new MutationObserver((mutations) => {
    let shouldFix = false;
    let shouldMark3d = false;
    mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) { // Element node
                    if (node.classList.contains('spf-product-card') || node.querySelector('.spf-product-card')) {
                        shouldFix = true;
                        shouldMark3d = true;
                    }
                }
            });
        }
    });
    if (shouldFix) {
        fixProductCardImages();
        renderCollectionColourSwatches();
    }

    if (shouldMark3d) {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType !== 1) return;

                if (node.classList.contains('spf-product-card')) {
                    markAngle3dProducts(node);
                    return;
                }

                if (node.querySelector('.spf-product-card')) {
                    markAngle3dProducts(node);
                }
            });
        });

        markAngle3dProducts();
    }
});

// Start observing the document body for added product cards
document.addEventListener("DOMContentLoaded", function() {
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
});

document.addEventListener("globoFilterRenderCompleted", fixProductCardImages);
document.addEventListener("globoFilterRenderCompleted", renderCollectionColourSwatches);
document.addEventListener("globoFilterRenderCompleted", () => {
    markAngle3dProducts();
    renderAngle3dLabels();
});

// Also run it periodically for a few seconds after DOM content is loaded to catch any late rendering
document.addEventListener("DOMContentLoaded", function() {
    let count = 0;
    const interval = setInterval(() => {
        fixProductCardImages();
        renderCollectionColourSwatches();
        markAngle3dProducts();
        renderAngle3dLabels();
        count++;
        if (count > 20) clearInterval(interval); // Run for ~10 seconds
    }, 500);
});

document.addEventListener("DOMContentLoaded", function() {
    renderCollectionColourSwatches();
    markAngle3dProducts();
    renderAngle3dLabels();
});
